// import React from 'react'
import CoreFeatures from './components/home/CoreFeatures';
import PricingCards from './components/home/Pricingcard';
import WhyChooseUs from './components/home/WhyChooseUs';
import FAQ from './components/home/Faqs';
import Footer from './components/Footer';
import Hero from './components/home/Hero';
import KeyFeaturesBenefits from './components/home/KeyFeaturesBenefits';
import PromoBanner from './components/home/PromoBanner';

const Home = () => {
  return (
    <div>
      <Hero />
      <CoreFeatures />
      <KeyFeaturesBenefits />
      <PromoBanner />
      <WhyChooseUs />
      <PricingCards />
      <FAQ />
      <Footer />
    </div>
  );
};

export default Home;
